"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _labelWrapper = require("../styles/labelWrapper"),
    _Text = _interopRequireDefault(require("../../Text"));

function LabelWrapper(a) {
  var b = a.children,
      c = a.className,
      d = a.label,
      e = a.id,
      f = a.extraLabelContent,
      g = a.disabled,
      h = a.helper,
      i = a.prefixDagger,
      j = a.prefixDoubleDagger,
      k = a.suffixDagger,
      l = a.suffixDoubleDagger,
      m = a.required,
      n = a.divContainer,
      o = a.notFullWidth;
  if (!d && !h) return b;

  var p = _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("div", {
    className: _labelWrapper.LABEL_HEADER
  }, d && _react["default"].createElement(_Text["default"], {
    className: _labelWrapper.LABEL,
    label: !0,
    disabled: g,
    prefixDagger: i,
    prefixDoubleDagger: j,
    suffixDagger: k,
    suffixDoubleDagger: l,
    required: m
  }, d), f || null), b, h && _react["default"].createElement(_Text["default"], {
    className: _labelWrapper.HELPER,
    disabled: g,
    caption: !0
  }, h));

  return n ? _react["default"].createElement("div", {
    className: (0, _classnames["default"])((0, _labelWrapper.LABEL_CONTAINER)({
      notFullWidth: o
    }), c)
  }, p) : _react["default"].createElement("label", {
    className: (0, _classnames["default"])((0, _labelWrapper.LABEL_CONTAINER)({
      notFullWidth: o
    }), c),
    htmlFor: e
  }, p);
}

var _default = (0, _react.memo)(LabelWrapper);

exports["default"] = _default;